<template>
  <div id="app" class="verify-edu">
    <venus-img v-if="!$themeNative" class="img-bg" alt="学生特权认证" :src="$theme.bg" :options="{ w: 375, c: 0 }" />
    <verify-form :theme="$theme" :theme-native="$themeNative" />
    <x-footer v-if="!$themeNative" />
    <success-confirm ref="successConfirm" />
  </div>
</template>

<script>
import { EVENTS } from '@zhenguo/vue-jssdk/business/VerifyEduForm/utils'
import VerifyForm from '@zhenguo/vue-jssdk/business/VerifyEduForm'
import XFooter from '@/business/Footer'
import SuccessConfirm from '@/business/Confirm'
import { getRedirectPage } from '@/utils'
import { getShareConfig } from '@/utils/share'
import { judgeIsEdu } from '@zhenguo/jssdk/api/user'

export default {
  components: {
    VerifyForm,
    XFooter,
    // 不能放表单里，因为认证完成后表单不可见
    SuccessConfirm,
  },
  created() {
    document.documentElement.style.background = this.$theme.bgColor
    if (this.$agent.native && this.$themeNative) return
    this.$configShare(getShareConfig(this.$theme, this.$themeNative))
  },
  mounted() {
    this.$knbUse('eh.show')
    window.$bus.$on(EVENTS.jump2activity, this.jump2activity)
    window.$bus.$on(EVENTS.completeVerified, this.showSuccessConfirm)
    window.$bus.$on(EVENTS.hasVerified, () => {
      if (this.$themeNative && this.$fromActivity) {
        this.checkAndBack()
      }
    })
  },
  methods: {
    @lx('mv', 'b_airbnb_2yt876uh_mv')
    async showSuccessConfirm() {
      if (this.$themeNative && this.$fromActivity) {
        // 站内认证直接后退
        this.$toasted.show('恭喜完成认证，现在可享学生权益')
        this.checkAndBack()
        return
      }
      this.$refs.successConfirm.show()
    },
    @errorHandler()
    async jump2activity(url) {
      this.$lxMC('b_airbnb_6bxipel0_mc')
      const userInfo = await this.$auth()
      this.$pushPage(getRedirectPage(url, userInfo, this.$theme.source))
    },
    @errorHandler()
    async checkAndBack() {
      const isEdu = await judgeIsEdu()
      if (isEdu) {
        this.$navigateBack()
      } else {
        setTimeout(() => {
          this.checkAndBack()
        }, 1000)
      }
    },
  },
}
</script>

<style lang="less">
@import '@zhenguo/x-scripts/styles/main.css';
.layout-max-width();

html {
  overflow: auto;
}
.img-bg {
  width: 100%;
}
</style>
